import React, { Component } from "react";
import TabContainer from "./components/Tabs/TabContainer/TabContainer";
import InfoBox from "./components/InfoBox/InfoBox";
import peerList from "./hypercube/Peers";
import metricData from "./hypercube/MetricData";
import infoBoxData from "./hypercube/infoBoxData";
import Tabs from "./components/Tabs/Tabs";
import schoolList from "./hypercube/Schools";
import InfoKey from "./components/InfoKey/InfoKey";
import SliderKey from "./components/SliderKey/SliderKey";
import DropDown from "./components/DropDown";
import * as math from "mathjs";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.setPeer = this.setPeer.bind(this);
    this.setSelectedPeer = this.setSelectedPeer.bind(this);
    this.setSchool = this.setSchool.bind(this);
    this.setDisabled = this.setDisabled.bind(this);
    this.setProjected = this.setProjected.bind(this);
    this.state = {
      current_score: 0,
      peerSelected: 0,
      domainSubtraction: 0,
      showProgress: 1,
      showClimate: 1,
      showAchievement: 1,
      showCollegeCareer: 1,
      showWalkthrough: 1,
      projected: {
        data: []
      },
      overall: {
        score: 0,
        earned: 0,
        possible: 0
      },
      walkthrough: [
        [
          "The SPR Calculator is a tool designed to help you better understand a school’s SPR score and how that score might change as the school’s performance changes.",
          <br />,
          <br />,
          <b>BEFORE YOU GET STARTED, PLEASE READ:</b>,
          <ul>
            <li>
              The SPR Calculator is a planning and goal-setting tool and should
              not be used as a replacement for official SPR scores. The official
              reports are available online at{" "}
              <a href="http://www.philasd.org/spr">www.philasd.org/spr</a>
            </li>
            <li>
              Some scores displayed in the tool may differ slightly from the
              official published reports due to rounding.
            </li>
          </ul>
        ],
        "To begin, select a report type and school from the dropdown menus. The school’s most recent data will appear. The different sections of the SPR, known as domains, are displayed in blue directly below the school name. You can select any domain by clicking on the domain name.",
        "Each performance indicator, or metric, within a domain is displayed below. For each metric, the gray number below the number line shows the school’s current performance. The black portion of the bar represents the scored range. Schools with performance below the scored range receive no points for a metric; schools with performance at or above the top of the scored range receive all of the points for a metric.",
        "To project what a school’s score would be with different data, drag the blue dot to the desired location. The “Projected Points” and “Projected Change” to the right of the bar will adjust to reflect points gained or lost from this change. On the left side of the screen, the school’s Overall and Domain scores will also adjust. A school may not receive certain metrics – for example, a high school that did not serve grade 12 in the most recent year will not receive the graduation rate metric. Any metrics that do not count towards a school’s score are shown with a dark gray box indicating the reason that the metric was not included. To include that metric in a school’s projected score, click on the “Click to Add” button to the right of the metric name.",
        [
          "If you have any questions about the SPR, please contact ",
          <a href="mailto:performanceframework@philasd.org">
            performanceframework@philasd.org
          </a>,
          "."
        ]
      ],
      walkthroughIndex: 0
    };
  }

  handleResetDomain(domain) {
    let newMetrics = this.state.metrics.data;
    for (let i = 0; i < newMetrics.length; i++) {
      if (newMetrics[i][0] === domain) {
        let newPossible, hardDisableFlag, disableFlag;
        newPossible = newMetrics[i][14];
        disableFlag = newMetrics[i][15];
        hardDisableFlag = newMetrics[i][15];
        newMetrics[i][15]
          ? (newMetrics[i][8] = 0)
          : (newMetrics[i][8] = newMetrics[i][14]);
        newMetrics[i][10] = newMetrics[i][11];
        newMetrics[i][2] = newMetrics[i][15];
        this.setProjected(
          domain,
          newMetrics[i][1],
          0,
          newMetrics[i][11],
          0,
          hardDisableFlag
            ? disableFlag
              ? 0
              : newPossible
            : disableFlag
            ? newPossible * -1
            : 0
        );
      }
    }
    let newProjected = this.state.projected.data;
    for (let j = 0; j < newProjected.length; j++) {
      if (newProjected[j][0] === domain) {
        newProjected[j][2] = 0;
        newProjected[j][3] = 0;
      }
    }
    this.setState({
      metrics: { data: newMetrics },
      projected: { data: newProjected }
    });
  }

  setDisabled(domain, metric, disableFlag) {
    let newMetrics = this.state.metrics.data,
      newValue,
      newPossible;
    let hardDisableFlag, newProjected;
    for (let i = 0; i < newMetrics.length; i++) {
      if (newMetrics[i][0] === domain && newMetrics[i][1] === metric) {
        hardDisableFlag = newMetrics[i][15];
        newMetrics[i][2] = disableFlag;
        disableFlag
          ? (newMetrics[i][8] = 0)
          : (newMetrics[i][8] = newMetrics[i][14]);
        newValue = disableFlag ? 0 : newMetrics[i][11];
        newPossible = newMetrics[i][14];
        newProjected = newMetrics[i][9] ? newMetrics[i][9] : 0;
      }
    }
    this.setProjected(
      domain,
      metric,
      disableFlag
        ? hardDisableFlag
          ? 0
          : newProjected * -1
        : hardDisableFlag
        ? newProjected
        : 0,
      newValue,
      0,
      hardDisableFlag
        ? disableFlag
          ? 0
          : newPossible
        : disableFlag
        ? newPossible * -1
        : 0
    );
    this.setState({
      metrics: { data: newMetrics }
    });
  }
  setProjected(
    domain,
    metric,
    projectedChange,
    value,
    projectedDifference,
    pointsPossible
  ) {
    let newMetrics = this.state.metrics.data;
    for (let i = 0; i < newMetrics.length; i++) {
      if (newMetrics[i][0] === domain && newMetrics[i][1] === metric) {
        newMetrics[i][10] = value;
      }
    }
    let newProjected = this.state.projected.data,
      found = false;

    for (let j = 0; j < newProjected.length; j++) {
      if (newProjected[j][0] === domain && newProjected[j][1] === metric) {
        newProjected[j][2] = math.round(projectedChange, 4);
        newProjected[j][3] = projectedDifference;
        newProjected[j][4] = pointsPossible;
        found = true;
      }
    }
    if (!found)
      newProjected.push([
        domain,
        metric,
        projectedChange,
        projectedDifference,
        pointsPossible
      ]);

    this.setState({
      projected: { data: newProjected }
    });
  }

  setPeer(peer) {
    let peerGroupName = this.state.peergroups.data.filter(item => {
      return Number(item[1]) === Number(peer);
    });
    this.setState(
      {
        peerSelected: Number(peer),
        peerGroup: peerGroupName[0][0],
        domainSubtraction: Number(peer) === 0 ? -2 : -3,
        showCollegeCareer: Number(peer) === 0 ? 1 : 0
      },
      () => {
        //this.getReducedSchools(this.state.schools.data)
      }
    );
  }
  setSelectedPeer(peer) {
    let peerGroupName = this.state.peergroups.data.filter(item => {
      return Number(item[1]) === Number(peer);
    });
    this.setState(
      {
        peerSelected: Number(peer),
        peerGroup: peerGroupName[0][0],
        domainSubtraction: Number(peer) === 0 ? -2 : -3,
        showCollegeCareer: Number(peer) === 0 ? 1 : 0,
        reducedSchools: []
      },
      () => {
        this.getReducedSchools(this.state.schools.data);
      }
    );
  }
  setSchool(school) {
    this.setState(
      {
        schoolSelected: school,
        projected: { data: [] }
      },
      () => {
        this.getMetrics(this.props.engine);
      }
    );
  }

  getPeergroups(engine) {
    engine.createSessionObject(peerList).then(peers => {
      peers
        .getLayout()
        .then(layout => {
          let dataArray = {};
          const values = layout.qHyperCube.qDataPages[0].qMatrix;
          const data = [];
          for (let m = 0; m < values.length; m++) {
            data.push([
              values[m][0]["qText"],
              parseInt(values[m][0]["qElemNumber"], 0)
            ]);
          }
          dataArray = { data };
          this.setState({ peergroups: dataArray });
          this.setPeer(data[0][1]);
          this.getSchools(engine);
        })
        .catch(err => console.log(err));
    });
  }

  getSchools(engine) {
    engine.createSessionObject(schoolList).then(schools => {
      schools
        .getLayout()
        .then(
          schools.getLayout().then(layout => {
            let dataArray = {};
            const values = layout.qHyperCube.qDataPages[0].qMatrix;
            const data = [];
            for (let m = 0; m < values.length; m++) {
              data.push([
                values[m][0]["qText"],
                parseInt(values[m][0]["qElemNumber"], 0),
                values[m][2]["qText"],
                values[m][1]["qText"]
              ]);
            }
            dataArray = { data };
            this.setState({ schools: dataArray }, () => {
              this.getReducedSchools(this.state.schools.data);
            });
          })
        )
        .catch(err => console.log(err));
    });
  }

  getReducedSchools(data) {
    let schools = data.filter(item => {
      return item[3] === this.state.peerGroup;
    });
    this.setState({ reducedSchools: schools }, () => {
      this.setSchool(this.state.reducedSchools[0][1]);
    });
  }

  getMetrics(engine) {
    engine.createSessionObject(metricData).then(object => {
      object
        .selectHyperCubeValues(
          "/qHyperCubeDef",
          0,
          [parseInt(this.state.schoolSelected)],
          false
        )
        .then(
          object
            .getHyperCubeData("/qHyperCubeDef", [
              { qTop: 0, qLeft: 0, qHeight: 200, qWidth: 16 }
            ])
            .then(hyperCube => {
              let dataArray = {},
                baseData = [];
              const values = hyperCube[0].qMatrix;

              values.map((m, i) => {
                baseData.push([
                  values[i][1]["qText"],
                  values[i][2]["qText"] || "",
                  Number(values[i][3]["qNum"]) >= 992 &&
                  Number(values[i][3]["qNum"]) < 999
                    ? 1
                    : 0,
                  Number(values[i][3]["qNum"]),
                  Number(values[i][5]["qNum"]),
                  Number(values[i][6]["qNum"]),
                  Number(values[i][7]["qNum"]),
                  Number(values[i][8]["qNum"]),
                  Number(values[i][9]["qNum"]),
                  Number(values[i][10]["qNum"]),
                  Number(values[i][7]["qNum"])
                    ? (Number(values[i][7]["qNum"]) /
                        Number(values[i][8]["qNum"])) *
                      100
                    : Number(values[i][11]["qNum"]),
                  Number(values[i][7]["qNum"])
                    ? (Number(values[i][7]["qNum"]) /
                        Number(values[i][8]["qNum"])) *
                      100
                    : Number(values[i][11]["qNum"]),
                  Number(values[i][10]["qNum"]),
                  Number(values[i][12]["qNum"]),
                  Number(values[i][9]["qNum"]),
                  Number(values[i][3]["qNum"]) >= 992 &&
                  Number(values[i][3]["qNum"]) < 999
                    ? 1
                    : 0,
                  Number(values[i][13]["qNum"]),
                  values[i][4]["qText"]
                ]);
              });
              let data = baseData
                .filter(item => {
                  return item[17] === this.state.peerGroup;
                })
                .sort((a, b) => (Number(a[13]) - Number(b[13]) ? -1 : 1));
              dataArray = { data };
              this.setState({ metrics: dataArray });
              this.getInfoBoxData(this.props.engine);
            })
        )
        .catch(err => console.log(err));
    });
  }

  getInfoBoxData(engine) {
    engine.createSessionObject(infoBoxData).then(object => {
      object
        .selectHyperCubeValues(
          "/qHyperCubeDef",
          0,
          [parseInt(this.state.schoolSelected)],
          false
        )
        .then(
          object
            .getHyperCubeData("/qHyperCubeDef", [
              { qTop: 0, qLeft: 0, qHeight: 100, qWidth: 5 }
            ])
            .then(hyperCube => {
              let dataArray = {},
                baseData = [];
              const values = hyperCube[0].qMatrix;
              values.map((m, i) => {
                let reportType = values[i][2]["qText"];
                let domainRaw = values[i][1]["qText"];
                let domain =
                  domainRaw.charAt(0).toUpperCase() +
                  domainRaw.toLowerCase().slice(1);
                baseData.push([
                  domain,
                  Number(math.round(values[i][3]["qNum"], 4)),
                  Number(math.round(values[i][4]["qNum"], 4)),
                  Number(
                    //math.round(
                    (Number(values[i][4]["qNum"]) /
                      Number(values[i][3]["qNum"])) *
                      100
                    //,0
                  ),
                  values[i][2]["qText"],
                  reportType
                ]);
              });
              let data = baseData.filter(item => {
                return item[5] === this.state.peerGroup;
              });
              dataArray = { data };
              let overallScore = [],
                overallEarned = [],
                overallPoss = [],
                overallEarnedReduced,
                overallPossReduced;
              data
                .filter(item => {
                  return (
                    Number(item[1]) > 0 && item[4] === this.state.peerGroup
                  );
                })
                .map(dataItem => {
                  overallPoss.push(dataItem[1]);
                  overallEarned.push(dataItem[2]);
                });
              overallEarnedReduced =
                //math.round(
                overallEarned.reduce((p, s) => {
                  return p + s;
                });
              //,1
              overallPossReduced =
                //math.round(
                overallPoss.reduce((p, s) => {
                  return p + s;
                });
              //,1
              overallScore =
                //math.round(
                (overallEarnedReduced / overallPossReduced) * 100;
              //,0
              let domains = [];
              for (let m = 0; m < data.length; m++) {
                if (data[m][1] > 0) {
                  domains.push(data[m][0]);
                }
              }
              this.setState({
                infoBox: dataArray,
                domains: domains,
                overall: {
                  score: overallScore,
                  earned: overallEarnedReduced,
                  possible: overallPossReduced
                }
              });
            })
        )
        .catch(err => console.log(err));
    });
  }

  async loadData() {
    const engine = this.props.engine;
    await this.getPeergroups(engine);
    this.getSchools(this.props.engine);
  }

  componentDidMount() {
    this.loadData();
  }

  render() {
    const engine = this.props.engine;
    return (
      <div className="App">
        <div className="rowLayout center" style={{ paddingTop: "15px" }}>
          <img
            src={require("./assets/images/sdplogo.png")}
            style={{ height: "50px" }}
            alt="The School District of Philadelphia"
          />
        </div>
        <div className="rowLayout center" style={{ marginTop: "-.2em" }}>
          <h3
            style={{
              height: "18px",
              fontSize: "1.2em",
              color: "#0b315b",
              fontFamily: "usual,sans-serif",
              fontStyle: "normal"
            }}
          >
            School District of Philadelphia: School Progress Report (SPR)
            Calculator
          </h3>
        </div>

        <div
          className="walkthrough_hide"
          style={{ display: !this.state.showWalkthrough ? "" : "none" }}
        >
          <div
            onClick={() => {
              this.setState({
                showWalkthrough: 1
              });
            }}
            className={
              this.state.showWalkthrough
                ? "hideButton hbHide"
                : "hideButton hbShow"
            }
          >
            <i className="expand" />
            {this.state.showWalkthrough
              ? "Hide Instructions"
              : "Show Instructions"}
          </div>
        </div>

        <div
          className="walkthrough"
          style={{ display: this.state.showWalkthrough ? "" : "none" }}
        >
          <div className="title">Instructions</div>
          <div
            onClick={() => {
              this.setState({
                showWalkthrough: 0
              });
            }}
            className={
              this.state.showWalkthrough
                ? "hideButton hbHide"
                : "hideButton hbShow"
            }
          >
            <i className="expand" />
            {this.state.showWalkthrough ? "Hide" : "Show"}
          </div>
          <div className="right">
            <div
              className="next"
              onClick={() => {
                this.setState({
                  walkthroughIndex:
                    this.state.walkthroughIndex >=
                    this.state.walkthrough.length - 1
                      ? 0
                      : this.state.walkthroughIndex + 1
                });
              }}
            >
              {this.state.walkthroughIndex >= this.state.walkthrough.length - 1
                ? "Start Over"
                : "Next Step"}
              <i className="arrow" />
            </div>
          </div>
          <div className="text">
            {this.state.walkthrough[this.state.walkthroughIndex]}
          </div>
        </div>
        <div className="rowLayout " style={{ height: "100%" }}>
          <div className="infoBoxGrid">
            <div
              className="rowLayout center"
              style={{
                display: "block",
                paddingBottom: "9px",
                marginBottom: "12px",
                backgroundColor: "#e6eaee",
                borderRadius: "8px",
                height: "100px",
                border: "1px solid #dfdfdf"
              }}
            >
              <div
                className="col-12"
                style={{
                  width: "70%",
                  paddingTop: "30px"
                }}
              >
                <InfoKey />
              </div>
            </div>
            <div id="ScoresRow">Scores</div>
            <div id="OverallRow">
              {this.state.overall &&
                this.state.overall.score &&
                this.state.projected &&
                this.state.projected.data &&
                (() => {
                  let pData = [0],
                    pPossible = [0];
                  for (let l = 0; l < this.state.projected.data.length; l++) {
                    pData.push(this.state.projected.data[l][2]);
                  }
                  for (let l = 0; l < this.state.projected.data.length; l++) {
                    pPossible.push(this.state.projected.data[l][4]);
                  }
                  let projPossible =
                    //math.round(
                    this.state.overall.possible +
                    +this.state.domainSubtraction +
                    pPossible.reduce((p, s) => {
                      return p + s;
                    });
                  //,2
                  let projOverOut =
                    //math.round(
                    this.state.overall.earned +
                    pData.reduce((p, s) => {
                      return p + s;
                    });
                  //,2
                  /*  let projOverScore = math.round(
                    (projOverOut / this.state.overall.possible) * 100,
                    0
                  ); */
                  return (
                    <div className="domainArea">
                      <div className="row domainTitleRow">
                        <div className="col-12">
                          <h2 className="domainHeader">
                            Overall
                            {//The below is to check if domains should be displayed. This represented SPRCALC-106 AW20190115
                            50 >
                            this.state.overall.possible +
                              this.state.domainSubtraction
                              ? "*"
                              : ""}
                          </h2>
                        </div>
                      </div>
                      <div className="row">
                        <div
                          key={Math.random()}
                          className="rowLayout infoBoxRow"
                        >
                          <div className="col-6 infoBoxContainer">
                            <InfoBox
                              current_score={
                                math.round(
                                  100 *
                                    (this.state.overall.earned /
                                      (this.state.overall.possible +
                                        this.state.domainSubtraction)),
                                  0
                                ) /* this.state.overall.score */
                              }
                              label="Current"
                              score={
                                math.round(
                                  100 *
                                    (this.state.overall.earned /
                                      (this.state.overall.possible +
                                        this.state.domainSubtraction)),
                                  0
                                )
                                /* this.state.overall.score */
                              }
                              outofnum={this.state.overall.earned.toFixed(2)}
                              outofden={
                                this.state.overall.possible +
                                this.state.domainSubtraction
                              }
                            />
                          </div>
                          <div className="col-6 infoBoxContainer">
                            <InfoBox
                              current_score={math.round(
                                100 *
                                  (this.state.overall.earned /
                                    (this.state.overall.possible +
                                      this.state.domainSubtraction)),
                                0
                              )}
                              label="Projected"
                              score={math.round(
                                100 * (projOverOut / projPossible),
                                0
                              )}
                              outofnum={
                                projOverOut > projPossible
                                  ? projPossible.toFixed(2)
                                  : projOverOut.toFixed(2)
                              }
                              outofden={projPossible}
                            />
                          </div>
                        </div>
                        {50 >
                        this.state.overall.possible +
                          this.state.domainSubtraction ? (
                          <div className="domainPointsFootnote">
                            *School is not eligible for enough points possible
                            for score to appear in this year's printed report.
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })()}
            </div>
            {this.state.infoBox &&
              this.state.infoBox.data &&
              this.state.projected &&
              this.state.projected.data &&
              this.state.infoBox.data
                .filter(item => {
                  return Number(item[1]) > 0;
                })
                .map(infoBoxData => {
                  let pFilterData = this.state.projected.data.filter(item => {
                    return (
                      item[0].toLowerCase() === infoBoxData[0].toLowerCase()
                    );
                  });
                  let pData = [0],
                    pPossible = [0];
                  for (let k = 0; k < pFilterData.length; k++) {
                    pData.push(pFilterData[k][2]);
                  }
                  for (let k = 0; k < pFilterData.length; k++) {
                    pPossible.push(pFilterData[k][4]);
                  }
                  let projPossible =
                    //Comment below to reduce by 2.
                    infoBoxData[0] === "Progress"
                      ? +this.state.domainSubtraction +
                        math.round(
                          infoBoxData[1] +
                            pPossible.reduce((p, s) => {
                              return p + s;
                            }),
                          4
                        )
                      : math.round(
                          infoBoxData[1] +
                            pPossible.reduce((p, s) => {
                              return p + s;
                            }),
                          4
                        );
                  let projOut = math.round(
                    infoBoxData[2] +
                      pData.reduce((p, s) => {
                        return p + s;
                      }),
                    4
                  );
                  /* let projScore = math.round(
                    (projOut / 
                      infoBoxData[1] ) * 100,
                    0
                  ); */
                  function titleCase(str) {
                    var splitStr = str.toLowerCase().split(" ");
                    for (var i = 0; i < splitStr.length; i++) {
                      splitStr[i] =
                        splitStr[i].charAt(0).toUpperCase() +
                        splitStr[i].substring(1);
                    }
                    return splitStr.join(" ");
                  }
                  return (
                    <div
                      key={Math.random()}
                      style={{
                        order:
                          infoBoxData[0] === "Achievement"
                            ? 1
                            : infoBoxData[0] === "Progress"
                            ? 2
                            : infoBoxData[0] === "Climate"
                            ? 3
                            : infoBoxData[0] === "College & career"
                            ? 4
                            : null
                      }}
                      className="domainArea"
                    >
                      <div className="domainContainer">
                        <span className="domainHeader">
                          {titleCase(infoBoxData[0])}
                          {//The below is to check if domains should be displayed. This represented SPRCALC-106 AW20190115
                          infoBoxData[0] === "Achievement"
                            ? infoBoxData[1] < 30 / 2
                              ? "*"
                              : ""
                            : infoBoxData[0] === "Progress"
                            ? infoBoxData[1] < 40 / 2
                              ? "*"
                              : ""
                            : infoBoxData[0] === "Climate"
                            ? infoBoxData[1] < 10 / 2
                              ? "*"
                              : ""
                            : infoBoxData[0] === "College & career"
                            ? infoBoxData[1] < 20 / 2
                              ? "*"
                              : ""
                            : null}
                        </span>
                        <span className="resetDomain">
                          <div
                            className="resetButton resetInScore"
                            onClick={() =>
                              this.handleResetDomain(
                                infoBoxData[0].toUpperCase()
                              )
                            }
                          >
                            RESET
                          </div>
                        </span>
                      </div>
                      <div className="row">
                        <div
                          key={Math.random()}
                          className="rowLayout infoBoxRow"
                        >
                          <div className="col-6 infoBoxContainer">
                            <InfoBox
                              label="Current"
                              current_score={
                                (infoBoxData[0] === "Progress"
                                  ? infoBoxData[1] +
                                    this.state.domainSubtraction
                                  : infoBoxData[1]) === 0
                                  ? 0
                                  : math.round(
                                      (infoBoxData[2] /
                                        (infoBoxData[0] === "Progress"
                                          ? infoBoxData[1] +
                                            this.state.domainSubtraction
                                          : infoBoxData[1])) *
                                        100,
                                      0
                                    )
                              }
                              score={
                                (infoBoxData[0] === "Progress"
                                  ? infoBoxData[1] +
                                    this.state.domainSubtraction
                                  : infoBoxData[1]) === 0
                                  ? 0
                                  : math.round(
                                      (infoBoxData[2] /
                                        (infoBoxData[0] === "Progress"
                                          ? infoBoxData[1] +
                                            this.state.domainSubtraction
                                          : infoBoxData[1])) *
                                        100,
                                      0
                                    )
                              }
                              outofnum={infoBoxData[2]}
                              outofden={
                                infoBoxData[0] === "Progress"
                                  ? infoBoxData[1] +
                                    this.state.domainSubtraction
                                  : infoBoxData[1]
                              }
                            />
                          </div>
                          <div className="col-6 infoBoxContainer">
                            <InfoBox
                              label="Projected"
                              current_score={
                                (infoBoxData[0] === "Progress"
                                  ? infoBoxData[1] +
                                    this.state.domainSubtraction
                                  : infoBoxData[1]) === 0
                                  ? 0
                                  : math.round(
                                      (infoBoxData[2] /
                                        (infoBoxData[0] === "Progress"
                                          ? infoBoxData[1] +
                                            this.state.domainSubtraction
                                          : infoBoxData[1])) *
                                        100,
                                      0
                                    )
                              }
                              score={
                                projPossible === 0
                                  ? 0
                                  : math.round(
                                      (projOut / projPossible) * 100,
                                      0
                                    )
                              }
                              outofnum={projOut}
                              outofden={projPossible}
                            />
                          </div>
                        </div>
                        {infoBoxData[0] === "Achievement" ? (
                          infoBoxData[1] < 30 / 2 ? (
                            <div className="domainPointsFootnote">
                              *School is not eligible for enough points possible
                              for score to appear in this year's printed report.
                            </div>
                          ) : (
                            ""
                          )
                        ) : infoBoxData[0] === "Progress" ? (
                          infoBoxData[1] < 40 / 2 ? (
                            <div className="domainPointsFootnote">
                              *School is not eligible for enough points possible
                              for score to appear in this year's printed report.
                            </div>
                          ) : (
                            ""
                          )
                        ) : infoBoxData[0] === "Climate" ? (
                          infoBoxData[1] < 10 / 2 ? (
                            <div className="domainPointsFootnote">
                              *School is not eligible for enough points possible
                              for score to appear in this year's printed report.
                            </div>
                          ) : (
                            ""
                          )
                        ) : infoBoxData[0] === "College & career" ? (
                          infoBoxData[1] < 20 / 2 ? (
                            <div className="domainPointsFootnote">
                              *School is not eligible for enough points possible
                              for score to appear in this year's printed report.
                            </div>
                          ) : (
                            ""
                          )
                        ) : null}
                      </div>
                    </div>
                  );
                })}
          </div>

          <div className="sliderTabsContainer">
            <div
              className="row center rowLayout"
              style={{ marginTop: "-50px", paddingLeft: "0px" }}
            >
              <div className="col-2">
                <h5
                  className="center"
                  style={{
                    color: "#555",
                    marginBlockEnd: "auto",
                    marginTop: "30px",
                    marginBottom: "15px",
                    textAlign: "center"
                  }}
                >
                  Select a Report Type
                </h5>
                <div>
                  {this.state.peergroups && this.state.peergroups.data && (
                    <DropDown
                      engine={engine}
                      list={this.state.peergroups.data}
                      selected={this.setSelectedPeer}
                      /* setReportType={this.setDomainPoints} */
                    />
                  )}
                </div>
              </div>
              <div className="col-6">
                <h5
                  className="center"
                  style={{
                    color: "#555",
                    marginBlockEnd: "auto",
                    marginTop: "30px",
                    marginBottom: "15px",
                    textAlign: "center"
                  }}
                >
                  Select a School
                </h5>
                <div style={{ paddingLeft: "15px" }}>
                  {this.state.reducedSchools && (
                    <DropDown
                      engine={engine}
                      list={this.state.reducedSchools}
                      selected={this.setSchool}
                    />
                  )}
                </div>
              </div>
              <div className="col-4">
                <SliderKey />
              </div>
            </div>
            {this.state.metrics && this.state.metrics.data && (
              <Tabs>
                <div label="Achievement" show={1}>
                  <TabContainer
                    label="Achievement"
                    metrics={this.state.metrics}
                    sliderHandle={this.setProjected}
                    handlerDisable={this.setDisabled}
                  />
                </div>
                <div label="Progress" metrics={this.state.metrics} show={1}>
                  <TabContainer
                    label="Progress"
                    metrics={this.state.metrics}
                    sliderHandle={this.setProjected}
                    handlerDisable={this.setDisabled}
                  />
                </div>
                <div label="Climate" metrics={this.state.metrics} show={1}>
                  <TabContainer
                    label="Climate"
                    metrics={this.state.metrics}
                    sliderHandle={this.setProjected}
                    handlerDisable={this.setDisabled}
                  />
                </div>
                <div
                  label="College &amp; Career"
                  show={this.state.showCollegeCareer}
                >
                  <TabContainer
                    label="College &amp; Career"
                    metrics={this.state.metrics}
                    sliderHandle={this.setProjected}
                    handlerDisable={this.setDisabled}
                  />
                </div>
              </Tabs>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default App;
